// extracted by mini-css-extract-plugin
export var screenshot = "AppScreenshot-module--screenshot--Kexgv";
export var stacked = "AppScreenshot-module--stacked--3g8FR";
export var image = "AppScreenshot-module--image--qRreb";
export var copy = "AppScreenshot-module--copy--RS2+4";
export var copyJustifyStart = "AppScreenshot-module--copy-justify-start--YCYj1";
export var copyAlignCenter = "AppScreenshot-module--copy-align-center--ixeXs";
export var copyStacked = "AppScreenshot-module--copy-stacked--mcGxC";
export var copyStackedBelow = "AppScreenshot-module--copy-stacked-below--fPYdd";